export default __webpack_public_path__ + "static/media/receiving-transfer-eksternal.d0acf667.png";